import { render, staticRenderFns } from "./infoCardPage_list.vue?vue&type=template&id=1b38027e&scoped=true&"
import script from "./infoCardPage_list.vue?vue&type=script&lang=js&"
export * from "./infoCardPage_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b38027e",
  null
  
)

export default component.exports